function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
var _ref2 = /*#__PURE__*/React.createElement("metadata", null, " Svg Vector Icons : http://www.onlinewebfonts.com/icon ");
var _ref3 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  fill: "#ffffff",
  d: "M500,10c-164.2,0-309.3,81-398.1,205v-82.5c0-25.4-20.6-45.9-45.9-45.9c-25.4,0-45.9,20.6-45.9,45.9v183.8c0,25.4,20.6,45.9,45.9,45.9H255c25.4,0,45.9-20.6,45.9-45.9c0-25.4-20.6-45.9-45.9-45.9h-79.9C247.2,168.5,365.7,101.9,500,101.9c219.9,0,398.1,178.2,398.1,398.1c0,219.9-178.2,398.1-398.1,398.1c-219.9,0-398.1-178.2-398.1-398.1c0-25.4-20.6-45.9-45.9-45.9C30.6,454.1,10,474.6,10,500c0,270.6,219.4,490,490,490c270.6,0,490-219.4,490-490C990,229.4,770.6,10,500,10z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#ffffff",
  d: "M385,668.4l255.4-145.5c23.4-13.3,23.4-35.1,0-48.5L385,329c-23.4-13.3-42.6-2.4-42.6,24.2V644C342.4,670.8,361.6,681.7,385,668.4z"
}));
function SvgReplay(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, ["title", "titleId"]);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 1000 1000",
    enableBackground: "new 0 0 1000 1000",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3);
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgReplay);
export default __webpack_public_path__ + "media/replay.c305626a996a205e99b8a4b0fcc6c676.svg";
export { ForwardRef as ReactComponent };